import { CollapsiblePanel } from '@/app/components/CollapsiblePanel'
import { Headline2 } from '@/app/components/Typography'
import { ICourse } from '@/types/course'
import { useTranslations } from 'next-intl'
import React from 'react'

type CourseContentProps = {
  course: Pick<ICourse, 'programmeStructure'>
} & React.HTMLAttributes<HTMLDivElement>

export function CourseContent({ course, ...props }: CourseContentProps) {
  const t = useTranslations('CoursePage')
  if (
    !Array.isArray(course.programmeStructure) ||
    !course.programmeStructure.length
  ) {
    return null
  }

  return (
    <div
      {...props}
      className={`flex flex-col gap-6 md:gap-12 pb-8 md:pb-20 ${props.className ?? ''}`}
    >
      <Headline2 className="text-center">{t('what_will_you_learn')}</Headline2>
      <div className="flex flex-col gap-4">
        {course.programmeStructure.map((structure, index) => (
          <CollapsiblePanel
            key={index}
            header={structure.title}
            className="text-sm md:text-base"
          >
            {structure.description}
          </CollapsiblePanel>
        ))}
      </div>
    </div>
  )
}
